import { Component, Input } from '@angular/core';

/**
 * „Öffnen" as its own button in a library row (design: Creator › Bibliothek),
 * next to the row menu ⋮. A cell component for `app-table`; `open` is a
 * stable function from the page, so the cell's inputs do not change on every
 * change-detection pass (CLAUDE.md rule 18).
 */
@Component({
  selector: 'app-creator-open-cell',
  template: `
    <button nbButton type="button" size="small" appearance="outline" status="primary" alAnchor="creator.library-open" (click)="onClick($event)">
      {{ label }}
    </button>
  `,
  styles: [':host { display: flex; justify-content: flex-end; }'],
})
export class CreatorOpenCellComponent {
  @Input() label = '';
  @Input() row: unknown;
  @Input() open?: (row: any) => void;

  onClick(event: MouseEvent): void {
    event.stopPropagation();
    if (this.open && this.row) this.open(this.row);
  }
}
